/** @format */

import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import Box from "../../atoms/box/Box";
import Typography from "../../atoms/typography/Typography";

import { AuthVerifyEmailProps } from "./AuthVerifyEmail.types";

const AuthVerifyEmail: FC<AuthVerifyEmailProps> = ({ formikStore }) => {
  const { t } = useTranslation();
  return (
    <Box
      flexDirection="column"
      margin="250px 10% 0px 10%"
      position="relative"
      zIndex={9999}
    >
      <Typography
        variant="h1"
        style={{ position: "relative" }}
      >
        {t("auth:verifyTitle")}
      </Typography>
      <Typography
        variant="h1"
        style={{ position: "relative" }}
      ></Typography>

      <Box
        margin="25px 0px 24px 0px"
        gap="10px"
        flexDirection="column"
      >
        <Typography variant="bodyBg">
          {t("auth:emailReceive1")}
          <span style={{ fontWeight: 600 }}>
            {" "}
            {formikStore?.values?.email}{" "}
          </span>
          {t("auth:emailReceive2")}
        </Typography>

        <Box flexDirection="column">
          <Typography variant="buttonBg">
            {t("auth:emailNotReceived.title")}
          </Typography>
          <Typography variant="bodyBg">
            {t("auth:emailNotReceived.description")}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default AuthVerifyEmail;
